import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const WaIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 4.9 4.3.7.3 1.2.5 1.7.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3zM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2z" /></svg>
);

export function ShareWhatsApp({ video, titre, testid = "share-whatsapp", fichier = true }) {
  const [busy, setBusy] = useState(false);
  const url = new URL(video, window.location.origin).href;
  const texte = `${titre} — découvrez Vitalis en vidéo : ${url}\nDemandez votre démonstration sur vitalis-store.com`;

  const share = async () => {
    setBusy(true);
    try {
      if (fichier && navigator.canShare && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        const blob = await (await fetch(url)).blob();
        const file = new File([blob], url.split("/").pop(), { type: "video/mp4" });
        if (navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], title: titre, text: `${titre} — demandez votre démonstration sur vitalis-store.com` });
          return;
        }
      }
      window.open(`https://wa.me/?text=${encodeURIComponent(texte)}`, "_blank", "noopener");
    } catch (e) {
      if (e?.name !== "AbortError") { window.open(`https://wa.me/?text=${encodeURIComponent(texte)}`, "_blank", "noopener"); toast.info("Partage du lien de la vidéo"); }
    } finally { setBusy(false); }
  };

  return (
    <button onClick={share} disabled={busy} data-testid={testid}
      className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2 text-sm font-semibold text-white shadow-sm transition-transform hover:scale-[1.03] disabled:opacity-60">
      {busy ? <Loader2 size={16} className="animate-spin" /> : <WaIcon />} Partager sur WhatsApp
    </button>
  );
}
